
<div>
  <div style="margin-left: 80%; margin-bottom: 2%;" class="noPrint">
    <button [useExistingCss]="true"
            style="margin-right: 2%; margin-left: 2%; z-index: 10;font-size: 12px; font-weight: 600;"
            mat-raised-button color="primary"  printSectionId="print-section" ngxPrint>
      Print
    </button>
    <button mat-dialog-close class="btn" style="z-index: 10">Close</button>
  </div>

  <div class="wrapper" id="print-section">
    <!-- Fixed Header -->
    <div class="header">
      <span>वर्गणी नोंदणी/नुतनीकरण यादी</span> - 

  <strong *ngIf="selectedFilters.start">पासुन:</strong> {{ selectedFilters.start | date:'dd/MM/yyyy' }}
  <strong *ngIf="selectedFilters.end">|पर्यत:</strong> {{ selectedFilters.end | date:'dd/MM/yyyy' }}
  <strong *ngIf="selectedFilters.rcpt_number">|</strong> {{ selectedFilters.rcpt_number }}
  <strong *ngIf="selectedFilters.country">|</strong> {{ selectedFilters.country }}
  <strong *ngIf="selectedFilters.state">|</strong> {{ selectedFilters.state[0]?.state_name }}
  <strong *ngIf="selectedFilters.district">|</strong> {{ selectedFilters.district }}
  <strong *ngIf="selectedFilters.taluka">|</strong> {{ selectedFilters.taluka }}
  <strong *ngIf="selectedFilters.prant_name">|</strong> {{ selectedFilters.prant_name }}
  <strong *ngIf="selectedFilters.rep">|</strong> {{ selectedFilters.rep }}
  <strong *ngIf="selectedFilters.distribution_rep">|</strong> {{ selectedFilters.distribution_rep }}
  <strong *ngIf="selectedFilters.rcpt_type">|</strong> {{ selectedFilters.rcpt_type }}

    </div>

    <!-- Content Grid -->
    <div class="print-grid">
      <ng-container *ngFor="let data2 of dataSource; let i = index">
        <div class="grid-item">
          <!-- <span style="font-size: 14px; font-weight: bold;">
           {{ getSubTypeShort(data2['subscription_type']) }}
           {{ (data2['sub_perid_to_date'] | date:'M') }}/{{ data2['subno'] }}-{{ (data2['sub_perid_to_date'] | date:'yyyy') }}
          </span> -->
          
          <span style="font-size: 14px; font-weight: bold;">
            {{ getSubTypeShort(data2['subscription_type']) }}
            {{
            (data2['sub_perid_from_date1'] &&
            data2['sub_perid_from_date1'] !== '0000-00-00')
            ? (data2['sub_perid_to_date1'] | date:'M')
            : (data2['sub_perid_to_date'] | date:'M')
            }}/{{ data2['subno'] }}-{{
            (data2['sub_perid_from_date1'] &&
            data2['sub_perid_from_date1'] !== '0000-00-00')
            ? (data2['sub_perid_to_date1'] | date:'yyyy')
            : (data2['sub_perid_to_date'] | date:'yyyy')
            }}
          </span><br />

          <span *ngIf="data2.address?.length > 94" style="font-size: 13px; font-weight: bold;">
           {{ data2["name"] }}
          </span>
          <span *ngIf="data2.address?.length <= 94" style="font-size: 15px; font-weight: bold;">
            {{ data2["title"] }} {{ data2["name"] }}
          </span><br />

          <span style="font-weight: bold; display: block;"
                [style.font-size.px]="data2.address?.length > 94 ? 13 : 15">
            {{ data2["address"] }}
          </span>
          <span *ngIf="data2.taluka" style="font-weight: bold; display: block;"
                [style.font-size.px]="data2.address?.length > 94 ? 13 : 15">
            {{ data2["taluka"] }}
          </span>
          <span *ngIf="data2['pincode'] != 0" style="font-weight: bold;"
                [style.font-size.px]="data2.address?.length > 94 ? 13 : 15">
            <span *ngIf="data2.district">{{ data2["district"] }} - </span>
            {{ data2["pincode"] }} {{ data2["state"] }}  मो.क्र.-{{ data2["mobileNumber"] }}
          </span>
        </div>
      </ng-container>
    </div>
  </div>
</div>

